import type {Editor} from "slate";
import {ReactEditor} from "slate-react";

import {getDocumentTitle} from "../slate/helpers/editor-helpers.ts";
import {clearUnsavedChanges} from "../slate/helpers/insertion-helpers.ts";

import printContents from "./print-contents.ts";

export const printDocument = (editor: Editor): void => {
    clearUnsavedChanges(editor);
    const editorDOMElement = ReactEditor.toDOMNode(editor, editor);
    const title = getDocumentTitle(editor);

    printContents(editorDOMElement, title);
};
